var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NoteModal',{on:{"dismiss":function($event){return _vm.$emit('dismiss')}}},[_c('p',{staticClass:"font_blue"},[_vm._v("・"+_vm._s(_vm.$t('oilTreatmentNote.title')))]),_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('oilTreatmentNote.description'))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }